<template>
  <v-menu
    v-if="activeChild"
    v-model="menu"
    :close-on-content-click="false"
    max-width="400"
    offset-x
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" :attrs="attrs" :on="on">
        <v-list-item
          v-bind="attrs"
          v-on="on"
        >
          <v-list-item-avatar>
            <v-img
              :src="childAvatar"
              contain
            />
          </v-list-item-avatar>
          <v-list-item-title>{{ activeChild.id }}</v-list-item-title>
          <v-list-item-action>
            <v-icon>chevron_right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </slot>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img
              :src="childAvatar"
              :alt="childAvatarAlt"
            >
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ activeChild.nickname }}</v-list-item-title>
            <v-list-item-subtitle>{{ activeChild.id }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn
              icon
              outlined
              exact
              :to="{ name: 'profile' }"
            >
              <v-icon>edit</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list>
        <v-list-item color="grey lighten-3">
          <v-list-item-icon>
            <v-icon>badge</v-icon>
          </v-list-item-icon>
          <v-list-item-content v-if="childFullName">
            <v-list-item-subtitle>Full name</v-list-item-subtitle>
            <v-list-item-title class="font-weight-medium">
              {{ childFullName }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-title v-else>
            Name is not specified
          </v-list-item-title>
          <v-list-item-icon v-if="!childFullName">
            <v-icon color="orange">warning</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon>
            <v-icon>supervisor_account</v-icon>
          </v-list-item-icon>
          <v-list-item-content v-if="activeChild.parent_id">
            <v-list-item-subtitle>Parent id</v-list-item-subtitle>
            <v-list-item-title class="font-weight-medium">
              {{ activeChild.parent_id }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-title v-else>
            Not connected to parent
          </v-list-item-title>
          <v-list-item-icon v-if="!activeChild.parent_id">
            <v-icon color="orange">warning</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-item>
          <v-list-item-icon>
            <v-icon>school</v-icon>
          </v-list-item-icon>
          <v-list-item-content v-if="activeChild.school_id">
            <v-list-item-subtitle>School id</v-list-item-subtitle>
            <v-list-item-title class="font-weight-medium">
              {{ activeChild.school_id }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-title v-else>
            Not connected to school
          </v-list-item-title>
          <v-list-item-icon v-if="!activeChild.school_id">
            <v-icon color="orange">warning</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { AVATARS_FOLDER_URL } from '@/configs/urls';

export default {
  name: 'ChildProfileDrawerMenu',
  data() {
    return {
      menu: false,
      hints: true,
    };
  },
  computed: {
    ...mapGetters({
      activeChild: 'children/activeChildProfile',
    }),
    childAvatar() {
      return AVATARS_FOLDER_URL + this.activeChild.avatar;
    },
    childFullName() {
      return this.activeChild.first_name
        ? `${this.activeChild.first_name} ${this.activeChild.last_name}` : null;
    },
    childAvatarAlt() {
      return this.childFullName || 'Child avatar';
    },
  },
};
</script>
